__turbopack_context__.v({
  "applyMemCard": "SearchCpmponent-module__u0-acW__applyMemCard",
  "bounce": "SearchCpmponent-module__u0-acW__bounce",
  "elementDivider": "SearchCpmponent-module__u0-acW__elementDivider",
  "fadeIn": "SearchCpmponent-module__u0-acW__fadeIn",
  "mask": "SearchCpmponent-module__u0-acW__mask",
  "memCta": "SearchCpmponent-module__u0-acW__memCta",
  "root": "SearchCpmponent-module__u0-acW__root",
  "search": "SearchCpmponent-module__u0-acW__search",
  "searchBtn": "SearchCpmponent-module__u0-acW__searchBtn",
  "searchCard": "SearchCpmponent-module__u0-acW__searchCard",
  "searchFood": "SearchCpmponent-module__u0-acW__searchFood",
  "searchFoodOverlay": "SearchCpmponent-module__u0-acW__searchFoodOverlay",
  "suggestions": "SearchCpmponent-module__u0-acW__suggestions",
});
